module.exports = __webpack_public_path__ + "assets/img/binding-4.ef34cb1c.jpg";